// extracted by mini-css-extract-plugin
module.exports = {"mobile_linkRoot":"styles_mobile_linkRoot__G_the","mobile_rootBase":"styles_mobile_rootBase__8z7PQ"};